import { AvailabilitiesResponse } from '../../types'

interface DetermineResourceIdsParams {
  specialistId: string | undefined
  dayAvailability: AvailabilitiesResponse['dayAvailability'] | undefined
  clientStartDate: Date | undefined
  dateToISODateKey: (date: Date) => string
}

/**
 * Determines resource_ids for an appointment based on specialist availability and cabin availability.
 *
 * @param params - Parameters for determining resource_ids
 * @returns Array of resource IDs: [specialist_id] for single booking, or [specialist_id, cabin_id] for combined booking
 */
export const determineResourceIds = ({
  specialistId,
  dayAvailability,
  clientStartDate,
  dateToISODateKey,
}: DetermineResourceIdsParams): string[] | undefined => {
  if (!specialistId) {
    return undefined
  }

  // Check if there's a cabin available for this specialist on this day
  if (dayAvailability && clientStartDate) {
    const dayKey = dateToISODateKey(clientStartDate)
    const specialistTimeBlocks = dayAvailability[dayKey]?.[specialistId]

    // Check if any time block for this specialist has a cabin (extraResourceIds)
    const blockWithCabin = specialistTimeBlocks?.find((block) => block.extraResourceIds && block.extraResourceIds.length > 0)
    const cabin = blockWithCabin?.extraResourceIds?.[0]

    if (cabin) {
      // Combined booking: [specialist_id, cabin_id]
      return [specialistId, cabin]
    } else {
      // Single resource booking: [specialist_id]
      return [specialistId]
    }
  }

  // Fallback: just set the specialist_id if we don't have availability data
  return [specialistId]
}
